var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSideNo2 = function SvgSideNo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sideNO_2_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sideNO_2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF9036",
    d: "M2 21.906a1 1 0 0 0 1.496.868l8.482-4.847a1 1 0 0 1 1.03.023l7.458 4.71A1 1 0 0 0 22 21.815V1.629a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m8.33 15.379 4.665-5.475q.195-.24.353-.525t.27-.563.172-.525.06-.427l-.015-.495q0-.24-.143-.473-.142-.232-.36-.412-.217-.18-.472-.293t-.495-.112h-.405q-.24 0-.48.112-.24.113-.435.293t-.315.412-.12.473v.285H8.855v-.405q0-.63.255-1.17t.698-.938 1.057-.622 1.335-.225q.99 0 1.725.27t1.207.727.706 1.05.232 1.223q0 .435-.053.795-.052.36-.165.69-.112.33-.315.645-.202.315-.487.645-.345.39-1.013 1.08t-1.807 1.83h3.66v2.13z"
  }))));
};
export default SvgSideNo2;